import { initFancybox } from './js/fancybox';
import mobmenu from './js/mobmenu';
import startModals from './js/modals';
import initSliders from './js/swipers';
import yandexMap from './js/yandex-map';
import initInputMask from './js/inputMask';
import './sass/_entry.scss';
import initCart, { initSpinner } from './js/cart';
import initAddToCart from './js/cart/addToCart';
import { startTabs } from './js/tabs';
import { initCookieBlock } from './js/cookies';
import initQuickSearch from './js/quicksearch';
import { initFixedHeader } from './js/fixedHeader';
import { initScrollTop } from './js/scrollTop';
import { initBrandsSearch } from './js/brandsSearch';
import filter from './js/filter';
import { startAccordeons } from './js/accordeons';
import { initOnFlySearch } from './js/onFlySearch';
import accordion from './js/accordion.js';

mobmenu();
initSliders();
initFancybox();
yandexMap();
initInputMask();
initSpinner();
initCart();
initAddToCart();
startTabs();
startModals();
initCookieBlock();
initQuickSearch();
initFixedHeader();
initScrollTop();
initBrandsSearch();
filter();
startAccordeons();
initOnFlySearch();
accordion();
window.filter = filter;
